import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_OptTxPlanSig = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_OptTxPlanSig' className='file-pdf-document'>
            <div className='file-template'>

                <p className='w-750'><h3>TREATMENT PLAN SIGNATURES</h3></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>PERSON RECEIVING SERVICES</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbTreatmentProvide" name="cbTreatmentProvide" className='add-only' value="1" />
                            I confirm and agree with my involvement in the development of this treatment plan. My signature means that I agree with the
                            treatment to be provided.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="cbServiceProviders" name="cbServiceProviders" className='add-only' value="2" />
                            I understand that I have the choice of service providers and may change service providers at any time, by contacting the person
                            responsible for this treatment plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Person Receiving Services</span>
                            <span className='small'>(Required when person is his/her own legal guardian)</span>
                            <input type="text" id="txtReceivingServices" name="txtReceivingServices" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Signature
                        </td>
                        <td className='small w-300'>Print Name
                        </td>
                        <td className='small w-150'>Date
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='small w-750'>
                            <span className='eleHeader'>Legally Responsible Person</span>
                            <span className='small'>(Required if the person receiving services is not their own legal guardian)</span>
                            <input type="text" id="txtResponsiblePerson" name="txtResponsiblePerson" className='add-only'  />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Signature
                        </td>
                        <td className='small w-300'>Print Name
                        </td>
                        <td className='small w-150'>Date
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='small w-750'>
                            <span className='eleHeader'>Relationship to the individual</span>
                            <input type="text" id="txtRelationshipIndividual" name="txtRelationshipIndividual" className='add-only'   />
                        </td>
                    </tr>
                    <tr>
                        <td className='small w-750'>
                            <span className='eleHeader'>CLINICAL PROFESSIONAL:</span>
                            <span className='small'>The following signature confirms the responsibility of the clinical professional for the development of this plan. The signature indicates
                                agreement with the services/supports to be provided.
                            </span>
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Signature of Person responsible for the plan and credentials
                        </td>
                        <td className='small w-300'>Print Name and credentials
                        </td>
                        <td className='small w-150'>Date
                        </td>
                    </tr>
                </table>
                <p>
                    <span className='eleHeader'>MEDICAL SERVICE ORDERS</span>
                    <span className='small'>REQUIRED for all Medicaid funded services and state funded (IPRS) services.</span>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            My signature below confirms the following
                            <span className='small'>(Check all appropriate boxes.)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <span>Medical necessity for services requested is present, and constitutes the Service Order(s).</span>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbServiceOrder_Yes" name="rbServiceOrder" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbServiceOrder_No" name="rbServiceOrder" className='add-only' value="No" /> No 
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <span>The licensed professional who signs this service order has had direct contact with the individual.</span>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbLicensedProfessionalDirectContact_Yes" name="rbLicensedProfessionalDirectContact" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbLicensedProfessionalDirectContact_No" name="rbLicensedProfessionalDirectContact" className='add-only' value="No" /> No 
                        </td>
                    </tr>
                    <tr>
                        <td className='w-600'>
                            <span>The licensed professional who signs this service order has reviewed the individual`s assessment.</span>
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbLicensedProfessionalIndividualAssessment_Yes" name="rbLicensedProfessionalIndividualAssessment" className='add-only' value="Yes" /> Yes &nbsp;
                            <input type="radio" id="rbLicensedProfessionalIndividualAssessment_No" name="rbLicensedProfessionalIndividualAssessment" className='add-only' value="No" /> No 
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-300'>&nbsp; </td>
                        <td className='signature w-150'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-300'>Signature (Name/Title Required)
                        </td>
                        <td className='small w-300'>(Print Name)
                        </td>
                        <td className='small w-150'>Date
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>License #
                            <input type="text" id="txtLicenseNo" name="txtLicenseNo" className='add-only'  />
                        </td>
                    </tr>
                </table>



            </div>
        </form>

    )
}  
